import { getCurrentDateObject } from "../helpers/date-helper";
import { toInputDate } from "../helpers/string-format-helper";

export const formDataActivityCreate = (defaultData?: ActivityDto): FormParams => {
  return {
    items: {
      upperFields: [
        {
          element: 'input',
          type: 'text',
          id: 'title',
          placeHolder: 'Título da atividade',
          label: 'Título da atividade',
          defaultValue: defaultData ? defaultData.title : null,
        },
        {
          element: 'textarea',
          id: 'description',
          placeHolder: 'Descrição da atividade',
          label: 'Descrição da atividade',
          rows: 5,
          defaultValue: defaultData ? defaultData.description : null,
        },
        {
          element: 'input',
          type: 'date',
          id: 'dueOn',
          label: 'Data',
          minDate: toInputDate(getCurrentDateObject()),
          // dueOn já vem como "YYYY-MM-DD", o formato do input date; passar por
          // new Date() reintroduziria o erro de fuso.
          defaultValue: defaultData ? defaultData.dueOn : null,
        },
      ],
      bottomFields: [
        {
          element: 'input',
          type: 'file',
          id: 'attachment',
          label: 'Anexar arquivo',
        },
      ],
    },
    style: 'gray',
  };
};
